import React, { useState } from "react";
import CodeInput from "./CodeInput/CodeInput";
import { TextInLink, colors } from "@bluedot-innovation/bluedot-ui";
import Button from '@material-ui/core/Button'
import { mfaChallenge } from "../../../../services/api";
import Logo from "../../../presentation/logo";
import "./style.css";

const CODE_LENGTH = 6;

const MfaChallenge = ({
    mfaSession,
    clearSession,
    onSignInSuccess,
    email
}) => {
    const [code, setCode] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loggingIn, setLoggingIn] = useState(false);

    const handleSignIn = async () => {
        setLoggingIn(true);
        try {
            const mfaChallengeResponse = await mfaChallenge(mfaSession, code, email);
            onSignInSuccess(mfaChallengeResponse);
        } catch (error) {
            console.error(error)
            const expectedErrorLocation = error?.response?.data?.errorMessages?.errorDescription;
            if (expectedErrorLocation) {
                setErrorMessage(expectedErrorLocation);
            } else {
                setErrorMessage("An unexpected error occurred");
            };
        };
        setLoggingIn(false);
    };

    return (
        <div className="loginWrapper">
            <div className="logoWrapper">
                <Logo width="13.2rem" />
            </div>

            <h2 className="mainHeading" style={{color: colors.SECONDARY_ACCENT}}>
                Authenticate Your Account
            </h2>

            <p className="instructionsText">
                Please confirm your account by entering the authorization code
                generated by your authenticator app
            </p>

            {errorMessage && (
                <div className="nonFieldSpecificError" style={{color: colors.ERROR}}>
                    {errorMessage}
                </div>
            )}

            <CodeInput
                code={code}
                onUpdateCode={setCode}
                codeLength={CODE_LENGTH}
            />

            <Button
                type="submit"
                disabled={loggingIn || code.length !== CODE_LENGTH}
                variant="contained" 
                color="primary" 
                disableElevation
                onClick={() => handleSignIn()}
            >
                {code.length === CODE_LENGTH
                    ? "Submit"
                    : `${CODE_LENGTH - code.length} digits left`
                }
            </Button>

            <div className="cancelWrapper" onClick={clearSession}>
                <TextInLink color="#000">Cancel</TextInLink>
            </div>

        </div>
    );
};

export default MfaChallenge;